import { connect } from "react-redux";
import { AtendimentoViewProps, listPeriodo, mapDispatchToAtendimentoProps, mapStateToAtendimentoProps } from "../atendimento.controller";
import { Atendimento, FiltroAtendimento } from "../atendimento.model";
import { StripedDataGrid, Select as ViewList } from "../../../components/select";
import { AppBar, Avatar, Badge, Box, Card, CardActionArea, CardContent, Chip, Grid, IconButton, Paper, Stack, Toolbar, Typography, useTheme, Container } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { useCallback, useEffect, useRef, useState } from "react";
import { AtendimentoCadastro } from "./atendimento.cad";
import { Paciente } from "../../paciente/paciente.model";
import { formatData } from "../../../services/utils";
import { Tratamento } from "../../../config/data.types";
import AppTheme from "../../../mui/shared-theme/AppTheme";
import { EventAvailable, EventBusy, PrintRounded, Search } from "@mui/icons-material";
import Content from "../../../mui/sign-in-side/components/Content";
import { differenceInDays } from "date-fns";
import { useReactToPrint } from 'react-to-print';
import { PrintAtendimentoList } from "../../relatorio";
import { format } from "@react-input/mask";


const getSituacaoTratamento = (tratamento: Tratamento) => {
    let data_retorno = new Date(tratamento.data_retorno);
    let hoje = new Date();
    if (data_retorno > hoje) {//em dia
        let diff = differenceInDays(data_retorno, hoje)
        return <Chip label={`${diff} dias Em Dia`} variant="filled" color="success" />
    } else {//em atraso
        let diff = differenceInDays(hoje, data_retorno)
        return <Chip label={`${diff} dias Em Atraso`} variant="filled" color="error" />
    }
}

export const columnsAtendimentoGroup: GridColDef[] = [
    { field: 'paciente', headerName: 'Paciente', flex: 3, valueGetter: (value, row: Atendimento) => row.paciente.nome },
    { field: 'whatsapp', headerName: 'Whatsapp', flex: 2, valueGetter: (value, row: Atendimento) => format(row.paciente.whatsapp, { mask: "(__)_ ____-____", replacement: { _: /\d/ } }) },
    { field: 'tratamento.data_retorno', headerName: 'Data Retorno', flex: 3, valueGetter: (value, row: Atendimento) => formatData(row.tratamento.data_retorno) },
    { field: 'tratamento', headerName: 'Situação', flex: 3, renderCell: (prm) => getSituacaoTratamento(prm.value) },
    { field: 'obs', headerName: 'Observações', flex: 3 },
]


export const columnsAtendimento: GridColDef[] = [
    { field: 'paciente', headerName: 'Paciente', flex: 3, valueGetter: (value, row: Atendimento) => row.paciente.nome },
    { field: 'whatsapp', headerName: 'Whatsapp', flex: 2, valueGetter: (value, row: Atendimento) => format(row.paciente.whatsapp, { mask: "(__)_ ____-____", replacement: { _: /\d/ } }) },
    { field: 'tratamento.procedimento', headerName: 'Procedimento', flex: 2, renderCell: (prm) => { return <Chip label={prm.row.tratamento.procedimento.descricao} variant="filled" /> } },
    { field: 'tratamento.data_retorno', headerName: 'Data Retorno', flex: 3, valueGetter: (value, row: Atendimento) => formatData(row.tratamento.data_retorno) },
    { field: 'tratamento', headerName: 'Situação', flex: 3, renderCell: (prm) => getSituacaoTratamento(prm.value) },
    { field: 'obs', headerName: 'Observações', flex: 3 },
]

const bgEmdia = "#f89a31";
const bgAtrasado = "#737373"

function AtendimentoList(props: AtendimentoViewProps) {
    const { atendimentoActions, atendimentoState } = props
    const { error, loadingRows, msg, row, rows, showAlert, showDialogExluir, status, showCadModal, changeList, rowsTratamentosBySituacao, rowTratamentoGroup, filtro, showFormFiltro } = atendimentoState
    const { getAtendimentosByPaciente, filterAtendimentos, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue, setShowCadModal, novoAtendimento, setRowTratamentoGroup, setFiltro, setShowFormFiltro } = atendimentoActions
    const [hiddenPeriodoSelect, setHiddenPeriodoSelect] = useState(filtro.status)
    const refPrint = useRef<HTMLDivElement>(null);
    const handlePrint = useReactToPrint({ contentRef: refPrint });

    useEffect(() => {
        console.log("chamou useEffect AtendimentoList")
        filterAtendimentos(filtro)
    }, [])

    const handleRead = () => {
        filterAtendimentos(filtro)
    }

    const handleNovo = () => {
        novoAtendimento();
        setShowCadModal(true)
    }

    const handleAlterar = (row: any) => {
        set(row);
        setShowCadModal(true)
    }

    const handleCloseCadastro = () => {
        console.log("chamou handleCloseCadastro")
        setShowCadModal(false)
    }

    function Cadastro() {
        return AtendimentoCadastro({
            ...props,
            handleCloseView: handleCloseCadastro
        }).renderModal({
            handleClose: handleCloseCadastro,
            show: showCadModal,
            heigth: "100%",
        })
    }


    const GridStatusTratamento = () => {
        const theme = useTheme()

        return (
            <Box>
                <Grid
                    container
                    spacing={1}
                    columns={12}
                    sx={{ mb: (theme) => theme.spacing(1) }}
                >

                    {rowsTratamentosBySituacao.map((tratamento, idx) => (
                        <Grid key={idx} size={{ xs: 12, sm: 6, md: 4 }}>
                            <Card variant="highlighted" sx={{ height: '100%', flexGrow: 1 }}>

                                <CardContent>
                                    <Stack
                                        direction="column"
                                        sx={{ justifyContent: 'space-between', flexGrow: '1', gap: 1 }}
                                    >
                                        <Stack sx={{ justifyContent: 'space-between' }}>
                                            <Stack
                                                direction="row"
                                                sx={{ justifyContent: 'space-between', alignItems: 'center' }}
                                            >
                                                <Typography variant="subtitle1" component="p">
                                                    {tratamento.descricao}
                                                </Typography>
                                                <Chip label={tratamento.qt} variant="outlined" size="medium" />

                                            </Stack>
                                        </Stack>
                                        <Stack spacing={1} sx={{ flexDirection: "column", width: '100%', display: "flex" }}>
                                            <Paper variant="outlined" sx={{ bgcolor: bgEmdia }} elevation={5}  >
                                                <CardActionArea sx={{ padding: 1, flexDirection: "row", alignItems: "center" }} onClick={() => props.atendimentoActions.setRowTratamentoGroup({ descricao: tratamento.descricao, situacao: "Em Dia", rows: tratamento.em_dia })} >
                                                    <Grid container spacing={1} flexDirection={"row"} >
                                                        <Grid>
                                                            <Chip label={tratamento.em_dia.length} />
                                                        </Grid>
                                                        <Grid>
                                                            <Typography variant="caption" >Em Dia</Typography>
                                                        </Grid>
                                                    </Grid>
                                                </CardActionArea>
                                            </Paper>

                                            <Paper variant="outlined" sx={{ bgcolor: bgAtrasado }} elevation={5}  >
                                                <CardActionArea sx={{ padding: 1, flexDirection: "row", alignItems: "center" }} onClick={() => props.atendimentoActions.setRowTratamentoGroup({ descricao: tratamento.descricao, situacao: "Em Atraso", rows: tratamento.atrazados })} >
                                                    <Grid container spacing={1} flexDirection={"row"} >
                                                        <Grid>
                                                            <Chip label={tratamento.atrazados.length} />
                                                        </Grid>
                                                        <Grid>
                                                            <Typography>Em Atraso</Typography>
                                                        </Grid>
                                                    </Grid>
                                                </CardActionArea>
                                            </Paper>
                                        </Stack>

                                    </Stack>

                                </CardContent>

                            </Card>

                        </Grid>
                    ))}
                </Grid>
                {rowTratamentoGroup?.descricao && (
                    <>
                        <AppBar position="relative" sx={{ bgcolor: rowTratamentoGroup.situacao === "Em Dia" ? bgEmdia : bgAtrasado }} enableColorOnDark>
                            <Toolbar variant="dense">
                                {rowTratamentoGroup.situacao === "Em Dia" ? (
                                    <EventAvailable sx={{ mr: 2 }} />
                                ) : (
                                    <EventBusy sx={{ mr: 2 }} />
                                )}

                                <Typography variant="h6" component="div" sx={{ flexGrow: 1, color: "ActiveCaption" }}>
                                    {rowTratamentoGroup.descricao}
                                </Typography>
                                <Grid container flexDirection={"row"} alignItems={"center"} spacing={1}>
                                    <Grid>
                                        <Chip label={rowTratamentoGroup.rows.length} variant="filled" />
                                    </Grid>
                                    <Grid>
                                        <Chip label={rowTratamentoGroup.situacao} variant="filled" />
                                    </Grid>
                                    <Grid>
                                        <IconButton
                                            size="small"
                                            edge="end"
                                            color="inherit"
                                            aria-label="menu"
                                            onClick={handlePrint}
                                            title="Imprimir Atendimentos"
                                        >
                                            <PrintRounded />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            </Toolbar>
                        </AppBar>

                        <StripedDataGrid

                            rows={rowTratamentoGroup.rows}
                            columns={columnsAtendimentoGroup}
                            getRowId={row => row._id}
                            density={'compact'}
                            style={{ fontSize: '0.875rem' }}

                            hideFooterPagination={rowTratamentoGroup.rows.length<100}
                            hideFooter={rowTratamentoGroup.rows.length<100}

                            filterMode="client"
                            loading={loadingRows}
                            onRowClick={(ev) => {
                                handleAlterar(ev.row)
                            }}
                            pagination
                            pageSizeOptions={[100]}
                            slotProps={{ pagination: { labelDisplayedRows: (paginationInfo) => `${paginationInfo.from} - ${paginationInfo.to} de ${paginationInfo.count !== -1 ? paginationInfo.count : paginationInfo.to}` } }}
                            autoPageSize={false}
                        />


                    </>
                )}
            </Box>
        )
    }




    const handleFiltroSubmit = (value: FiltroAtendimento) => {
        setFiltro(value)
        setShowFormFiltro(false);
    }


    const List = () => {

        const [agrupado, setAgrupado] = useState(true)

        console.log("agrupado", agrupado)

        const handleMutatorFiltro = ([value, field]: any, state: any, { changeValue }: any) => {
            console.log("field", field)
            console.log("value", value)

            if (field === "status") {
                setHiddenPeriodoSelect(value)
            }

            changeValue(state, field, () => value)
        }

        return (
            <ViewList
                displayWidth={window.innerWidth}
                title={"Central de Atendimentos"}
                row={row}
                showAlert={showAlert}
                closeAlert={() => setShowAlert(false)}
                msg={msg}
                status={status}
                elevation={1}
                getRowId={(row) => row._id}
                handleOnChange={handleAlterar}
                actionsOnkeyEnter={handleAlterar}
                showSearchContainer={true}
                fontSize={20}
                setTextSearch={(text) => {
                    console.log(text, agrupado)
                    if (text.length === 0) {
                        console.log("agrupando")
                        setAgrupado(true)
                    } else {
                        console.log("desagrupando")
                        setAgrupado(false)
                    }
                }}
                textSearch={""}
                multFieldSearch={true}
                fieldSearch={["paciente.nome", "obs"]}
                orderBy="paciente.nome"
                columns={columnsAtendimento}
                rows={rows}
                loading={loadingRows}
                setRow={handleAlterar}
                changeList={changeList}
                buttonNew={{
                    show: true,
                    onClick: handleNovo
                }}
                buttonRefresh={{
                    show: true,
                    onClick: () => handleRead(),
                }}
                ListItemTextPrimary={(row: Atendimento) =>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography component={"span"}>{row.paciente.nome}</Typography>
                        <Typography component={"span"}>{row.data}</Typography>
                    </Box>
                }
                ViewBeforeGridList={() => agrupado ? <GridStatusTratamento /> : <></>}
                hidenGridNoData={true}
                hiddenGrid={agrupado}
                showFullFiltroForm={true}
                fullFiltroFormParams={{
                    showFormFiltro: showFormFiltro,
                    listFieldShow: [
                        { label: "Situação dos Atendimentos: ", name: "situacao", handleOnClick: () => setShowFormFiltro(true) },
                        { label: "Funcionário: ", name: "funcionario.nome", handleOnClick: () => setShowFormFiltro(true) },
                    ],
                    form: {
                        contentForm: [
                            { fieldName: "situacao", label: "Situacão Atendimento", type: "radio", key: "situacao", colunsXS: 12, colunsSM: 6, colunsMD: 6, radioOptionsValues: [{ label: "Ativo", value: "ativo" }, { label: "Inativo", value: "inativo" }, { label: "Todos", value: "todos" }], radioDefaultValue: "ativo" },
                            { fieldName: "status", label: "Situação Retorno", type: "radio", key: "situacao", colunsXS: 12, colunsSM: 6, colunsMD: 6, radioOptionsValues: [{ label: "Em Dia", value: "em_dia" }, { label: "Atrasado", value: "atrasado" }, { label: "Todos", value: "todos" }] },
                            {
                                fieldName: "periodo_em_dia", label: "Periodo retorno em dia", type: "select", key: "periodo_em_dia",
                                colunsXS: 12, colunsSM: 12, colunsMD: 6,
                                radioOptionsValues: listPeriodo.map(value => { return { label: value.periodo, value: value.qtdias } }),
                                handleChangeMutator: (mutator, values, formValues) => mutator(values, "periodo_em_dia"),
                                hidden: (value) => (value.status === "todos" || value.status === "atrasado")
                            },
                            {
                                fieldName: "periodo_em_atraso", label: "Periodo retorno em atraso", type: "select", key: "periodo_em_atraso",
                                colunsXS: 12, colunsSM: 12, colunsMD: 6, radioOptionsValues: listPeriodo.map(value => { return { label: value.periodo, value: value.qtdias } }),
                                handleChangeMutator: (mutator, values, formValues) => mutator(values, "periodo_em_atraso"),
                                hidden: (value) => (value.status === "todos" || value.status === "em_dia")
                            },
                        ],
                        buttonActions: [
                            { label: "Aplicar Filtro", icon: <Search />, color: "primary", variant: "outlined", type: "submit", disableType: "padraoForm" },
                            /* { label: "Load Itens", icon: <Search />, color: "primary", variant: "outlined", type: "button",handleOnClick:(values)=>itemCartProvider.readAllItensMov(values) }, */
                        ],
                        row: filtro,
                        handleMutator: handleMutatorFiltro,
                        handleOnSubmit: handleFiltroSubmit,
                        handleCancel: () => { },

                    }
                }}
                handleShowFiltroForm={() => setShowFormFiltro(!showFormFiltro)}



            />
        )
    }

    return (
        <div className="modulo">
            <Cadastro />
            <List />
            <div style={{ display: 'none' }}>
                <div ref={refPrint}>
                    <PrintAtendimentoList />
                </div>
            </div>
        </div>
    )

}

export default connect(mapStateToAtendimentoProps, mapDispatchToAtendimentoProps)(AtendimentoList);


